module.exports = __webpack_public_path__ + "img/earth_ground.d00967a7.svg";